import resolveAfter from './resolveAfter';

export default function delay(promise, ms = 0) {
    if (ms) {
        return resolveAfter(ms).then(() => promise);
    }
    return promise;
}
